import React from 'react';
import { List } from 'semantic-ui-react';

export const KsiSupportType = ({ value }) => {
  switch (value) {
    case 'case_story':
      return <List.Item key={value}>Kolesaun ba istória kazu</List.Item>;
    case 'advocacy':
      return <List.Item key={value}>Advokasia</List.Item>;
    case 'legal_support':
      return <List.Item key={value}>Apoiu legál</List.Item>;
    case 'organize_peasant_movement':
      return <List.Item key={value}>Organiza movimentu kamponezes</List.Item>;
    case 'community_sensibilization':
      return <List.Item key={value}>Sensibilisasaun komunidade</List.Item>;
    default:
      return '';
  }
};
